import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "itds-admin-token";

export const getToken = () => {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch (err) {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) {
      window.localStorage.setItem(TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(TOKEN_KEY);
    }
  } catch (err) {
    // Storage unavailable
  }
};

const authConfig = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
});

export const getAuthConfig = authConfig;

export const apiLogin = (email, password) =>
  axios.post(`${API_BASE}/admin/login`, { email, password });

export const apiMe = () => axios.get(`${API_BASE}/admin/me`, authConfig());

export const apiGetContent = () => axios.get(`${API_BASE}/site-content`);

export const apiSaveContent = (content) =>
  axios.put(`${API_BASE}/admin/site-content`, { content }, authConfig());

export const apiListMedia = () =>
  axios.get(`${API_BASE}/admin/media`, authConfig());

export const apiUploadMedia = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/admin/media`, form, authConfig());
};

export const apiDeleteMedia = (mediaId) =>
  axios.delete(`${API_BASE}/admin/media/${mediaId}`, authConfig());

export const apiUpdateCredentials = (payload) =>
  axios.put(`${API_BASE}/admin/credentials`, payload, authConfig());

export const apiGetLeads = () =>
  axios.get(`${API_BASE}/admin/leads`, authConfig());

export const apiDeleteLead = (leadId) =>
  axios.delete(`${API_BASE}/admin/leads/${leadId}`, authConfig());
